import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";

import {TranslateModule} from "@ngx-translate/core";
import {RoomStore} from "../../../store/room.store";
import {ReportHitConfirmationCommand} from "../../../../backend/commands/game/report-hit-confirmation.command";
import {ConfirmationStore} from "../../../store/confirmation.store";
import {YesNoDialogData} from "../../../shared/components/yes-no-dialog/yes-no-dialog.component";
import {Confirmation, ConfirmationResult} from "../../../../backend/model/confirmation.model";
import {toObservable} from "@angular/core/rxjs-interop";
import {filter, skip} from "rxjs";

export interface ConfirmationDialogData extends YesNoDialogData {
  self: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  imports: [
    MatButton,
    TranslateModule
  ],
  templateUrl: './replay-hit-after-report-confirmation-dialog.component.html',
  styleUrl: './replay-hit-after-report-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReplayHitAfterReportConfirmationDialogComponent {
  private readonly roomStore = inject(RoomStore);

  private readonly confirmationStore = inject(ConfirmationStore);

  data: ConfirmationDialogData = inject(MAT_DIALOG_DATA);

  confirmation = this.confirmationStore.report;

  voted = false;

  constructor(ref: MatDialogRef<any>) {
    toObservable(this.confirmationStore.report)
      .pipe(
        skip(1),
        filter((confirmation: Confirmation) => confirmation.result !== ConfirmationResult.PENDING),
      )
      .subscribe(() => ref.close());
  }

  vote(confirm: boolean) {
    if (this.voted) {
      return;
    }
    this.voted = true;
    this.roomStore.sendCommand(new ReportHitConfirmationCommand(confirm));
  }
}
